import React, { useState } from 'react'
import { Mutation, Query } from 'react-apollo'
import _ from 'lodash'
import { message, Popconfirm } from 'antd'
import {
  Div, Button, LoadingIcon,
} from 'konsys-ui'
import UploadFile from '../../components/common/upload'
import { REPLACE_POPUP } from '../../constants/graphql/mutation'
import { SHOW_POPUP } from '../../constants/graphql/query'
import { theme } from '../../styles/_variables'

const ImageBanner = ({ img, refetch }) => (
  <Div margin='16px 12px'>
    <img src={img} style={{ maxHeight: '250px', width: 'auto', display: 'block' }} />
    <Mutation
      mutation={REPLACE_POPUP}
    >
    {
      doReplacePopup => (
        <Popconfirm
          title="ยืนยันที่จะลบภาพนี้ ?"
          onConfirm={() => {
            doReplacePopup({
              variables: {
                image: '',
              },
            }).then(({ data }) => {
              if (data.replacePopUp) {
                if (data.replacePopUp.success) {
                  message.success(data.replacePopUp.message)
                  refetch()
                } else {
                  message.error(data.replacePopUp.message)
                }
              }
            })
          }}
          okText="ยืนยัน"
          cancelText="ยกเลิก"
        >
          <Button small ghost margin='8px 0 0' text='ลบรูปภาพนี้' />
        </Popconfirm>
      )
    }
    </Mutation>
  </Div>
)

const Popup = () => {
  const [newFileList, setNewFileList] = useState([])
  const [disabledButton, setDisabledButton] = useState(false)

  return (
    <Query
      query={SHOW_POPUP}
    >
    {
      ({ loading, data, refetch }) => {
        if (loading) return <Div margin='24px 0' textAlign='center'><LoadingIcon color={theme.color.grey} /></Div>
        if (!data.showPopUp.success) return <p>error something</p>
        return (
          <Div>
            <Mutation
              mutation={REPLACE_POPUP}
            >
            {
              doReplacePopup => (
                <Div>
                  <UploadFile
                    list={newFileList}
                    id='uploadFileId'
                    onChange={(fileList) => {
                      let upload = false
                      const allowFileType = ['jpg', 'jpeg', 'png']
                      for (let i = 0; i < fileList.length; i += 1) {
                        const splitName = fileList[i].name.split('.')
                        if (!_.includes(allowFileType, splitName[splitName.length - 1].toLowerCase())
                        || (newFileList.length > 0 && !_.isUndefined(_.find(newFileList, d => d.name === fileList[i].name)))) {
                          upload = false
                          break
                        } else {
                          upload = true
                        }
                      }
                      if (upload) {
                        const newUploadFileList = [...newFileList]
                        Object.keys(fileList).forEach((v) => {
                          if (v !== 'length') {
                            newUploadFileList.push(fileList[v])
                          }
                        })
                        setNewFileList(newUploadFileList)
                      } else {
                        message.error('สามารถอัพโหลดได้เฉพาะไฟล์ jpg, jpeg, png และไม่สามารถอัพรูปซ้ำได้')
                      }
                    }}
                    onRemoveFile={(fileName) => {
                      const newUploadFileList = [...newFileList]
                      _.remove(newUploadFileList, v => v.name === fileName)
                      setNewFileList(newUploadFileList)
                    }}
                    fileType="image/*"
                  />
                  <Button disabled={newFileList.length <= 0 || disabledButton} inverse fullWidth text='อัพโหลดรูปภาพใหม่' onClick={() => {
                    setDisabledButton(true)
                    doReplacePopup({
                      variables: {
                        image: newFileList[0],
                      },
                    }).then((resp) => {
                      setDisabledButton(false)
                      if (resp.data.replacePopUp) {
                        if (resp.data.replacePopUp.success) {
                          setNewFileList([])
                          message.success(resp.data.replacePopUp.message)
                          setTimeout(() => {
                            setNewFileList([])
                            refetch()
                          }, 3000)
                        } else {
                          message.error(resp.data.replacePopUp.message)
                        }
                      }
                    })
                  }} />
                </Div>
              )
            }
            </Mutation>
            <Div>
            {
              !_.isEmpty(data.showPopUp.popUp) && <ImageBanner img={data.showPopUp.popUp.popUpFileUri} refetch={() => refetch()} />
            }
            </Div>
          </Div>
        )
      }
    }
    </Query>
  )
}

export default Popup
